import BigNumber from 'bignumber.js'
import poolsConfig from 'config/constants/pools'
import dmdABI from 'config/abi/dmd.json'
import masterchefABI from 'config/abi/masterchef.json'
import multicall from 'utils/multicall'
import { getAddress, getMasterChefAddress } from 'utils/addressHelpers'
import { BIG_ZERO } from 'utils/bigNumber'

export const fetchPoolsTotalStaking = async () => {
  const pools = poolsConfig

  const callsPools = pools.map((poolConfig) => {
    return {
      address: getAddress(poolConfig.stakingToken.address),
      name: 'balanceOf',
      params: [getMasterChefAddress()],
    }
  })

  const poolsTotalStaked = await multicall(dmdABI, callsPools)

  return [
    ...pools.map((p, index) => ({
      sousId: p.sousId,
      totalStaked: new BigNumber(poolsTotalStaked[index]).toJSON(),
    })),
  ]
}

export const fetchPoolsWeight = async () => {
  const pools = poolsConfig

  const poolsWeight = await Promise.all(
    pools.map(async (pool) => {
      const [info, totalAllocPoint] = await multicall(masterchefABI, [
        {
          address: getMasterChefAddress(),
          name: 'poolInfo',
          // Only make masterchef calls if farm has pid
          params: [pool.sousId],
        },
        {
          address: getMasterChefAddress(),
          name: 'totalAllocPoint',
        },
      ])
      const allocPoint = info ? new BigNumber(info.allocPoint?._hex) : BIG_ZERO
      const poolWeight = totalAllocPoint ? allocPoint.div(new BigNumber(totalAllocPoint)) : BIG_ZERO
      return poolWeight
    }),
  )

  return [
    ...pools.map((p, index) => ({
      sousId: p.sousId,
      poolWeight: poolsWeight[index],
    })),
  ]
}
